module.exports = __webpack_public_path__ + "img/pool_connections.ea9efdc5.png";